<agm-map [latitude]="coordinates[0].latitude" [longitude]="coordinates[0].longitude" [zoom]="14" *ngIf="coordinates != null">
    <agm-marker [iconUrl]="iconFirst.iconUrl" [latitude]="coordinates[0].latitude" [longitude]="coordinates[0].longitude"></agm-marker>
    <agm-marker [iconUrl]="iconLast.iconUrl" [latitude]="coordinates[coordinates.length -1].latitude" [longitude]="coordinates[coordinates.length -1].longitude"></agm-marker>
    <agm-polyline [editable]="false" [strokeColor]="'#669DF6'" strokeWeight="5">
        <agm-polyline-point *ngFor="let data of coordinates" [latitude]="data.latitude" [longitude]="data.longitude">
        </agm-polyline-point>
    </agm-polyline>
</agm-map>
